import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import axios from "axios";
import { Table, Col, Input, Label } from "reactstrap";
import Header from '../../layout/Header/Header'


function Monitoring() {
  const { user } = useContext(AuthContext);

  const [statusHeroku, setStatusHeroku] = useState([])
  
  useEffect(()=>{
    axios
    .get(`https://qualyshop.herokuapp.com/`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((response) => {
      let allUsers = response.data.message;
      setStatusHeroku(allUsers);
    })
    .catch((err) => {
      console.log(err);
    });
  },[])
  return (
    <>
    <Header />
    <br />
    <br />
      <div className="container">
        <img src={"https://api.netlify.com/api/v1/badges/1d6c18e7-4227-4fc1-ae16-31b1d2cad78a/deploy-status"}></img>
        <br />
        <br />
        <Label>Heroku: {statusHeroku}</Label>
      </div>
    </>
  );
}

export default Monitoring;
